var Aneox;
(function (Aneox) {
  'use strict';

  var Wines = (function () {

    var locale;
    var router;
      
    var winePageElement;
    var wineBottleElement;
    var wineDetailsElement;
    var wineDownloadButton;

    var wineNameLeads = [
      'Bourgogne',
      'Meursault',
      'Saint-Aubin',
      'Puligny-Montrachet',
      'Crémant de Bourgogne',
      'Pommard',
      'Volnay'
    ];
    var wineNameSubleads = [
      '1er Cru',
      'Aligoté',
      'Rouge'
    ];
    var wineNameRegex = new RegExp('(' + wineNameLeads.join('|') + ')' + 
      '( ' + wineNameSubleads.join(' | ') + ' | )(.*)');

    function Wines(lang, routing) {
      locale = lang;
       router = routing;
        
      winePageElement = $('#wine');
      wineBottleElement = winePageElement.find('#wine-bottle');
      wineDetailsElement = winePageElement.find('#wine-details');
      wineDownloadButton = $('#wine-download-button');

      //renderLists();
    }
      
      
      
      

    function renderLists(locale) {
      //var whites = _.filter(Aneox.Data.Data.wines, { type: 'white' });
      var whites = _.filter(app.dataWhiteWines, {locale: locale});
      var fragment = $(document.createDocumentFragment());
      whites.forEach(function(wine) {
        fragment.append('<li class="wine-li"><a router-href="' + wine.localeNid + '">' +
          wine.name + '</a></li>');
      });
      $('#wines-white').empty().append(fragment);

      //var reds = _.filter(Aneox.Data.Data.wines, { type: 'red' });
      var reds = _.filter(app.dataRedWines, {locale: locale});
      fragment = $(document.createDocumentFragment());
      reds.forEach(function(wine) {
        fragment.append('<li class="wine-li"><a router-href="' + wine.localeNid + '">' +
          wine.name + '</a></li>');
      });
      $('#wines-red').empty().append(fragment);
    }

    Wines.prototype.renderLists = function(locale){
        renderLists(locale);
    }  
      
    Wines.prototype.openPage = function(id) {
        populatePage(id);
      $('#page-wrapper').addClass('noscroll');
      winePageElement.fadeIn();
    };
    
    Wines.prototype.closePage = function() {
      //setPage('wines');
      closeOverlay(winePageElement);
      //scroll.setManualScroll().decrementScrollRetainCount();
    }  
    
    function closeOverlay(element) {
          element.removeClass('active');
          TweenMax.to(element, .5, {
            display: 'none',
            ease: Power2.easeInOut
          });
    }

    function populatePage(id) {
      var wine = _.find(app.dataAllWines, { id: id });    
      var tmpWineLocale = _.find(wine.locales, { locale: locale.getLocale() });    
        
      //var winePDFPath =  (location.origin.length > 0)? location.origin +'/'+Aneox.Data.Config.desktopurl : 'http://www.'+Aneox.Data.Config.desktopurl;   
      var winePDFPath =  'http://www.'+Aneox.Data.Config.desktopurl;   
        
      wineDownloadButton.attr('href', winePDFPath+'/pdf/wine/' + tmpWineLocale.nid);
      //wineDownloadButton.attr('href', 'wine.php?id=' + id + '&locale=' + locale.getLocale());
      //var wine = _.find(Aneox.Data.Data.wines, { id: id });
      wineBottleElement.attr('src', wine.img);
      for (var detail in wine) {
        if (detail === 'name') {
          var name = wine[detail]
          .replace(wineNameRegex,
            '<span>$1</span>' +
            '<span>$2</span>' +
            '<span>$3</span>');
          $('#wine-name').html(name);
        } else if (detail === 'locales') {
          var wineLocale = _.find(wine[detail], { locale: locale.getLocale() });
          for (var localeDetail in wineLocale) {
            $('#wine-' + localeDetail).html(wineLocale[localeDetail]);
          }
        } else {
          $('#wine-' + detail).text(wine[detail]);
        }
      }
    }
      
    function setPage(nodeId) {
      if (nodeId === router.getNode().id) return;
      
      var path = router.getNodePath(nodeId, locale.getLocale());
      if (path === undefined) return;
        console.log(path);
      //router.setPath(path);
      router.setPath('/vins');
    }  

    return Wines;
  })();

  Aneox.Wines = Wines;
})(Aneox || (Aneox = {}));